var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1615_96254)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1615_96254",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1615_96254)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1615_96254",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1615_96254)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1615_96254",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1615_96254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.261 17.6399C2.1985 17.6399 2.13433 17.6399 2.0735 17.634C1.47766 17.5974 0.985996 17.4165 0.833496 16.7549V15.6799C0.888496 15.3824 0.925996 15.0807 1.00016 14.7899C1.26345 13.5742 1.84325 12.4496 2.68089 11.53C3.51852 10.6104 4.58424 9.92849 5.77016 9.5532C5.15162 9.19671 4.64979 8.66841 4.32556 8.03236C4.00132 7.39631 3.8686 6.67985 3.9435 5.96987C3.96304 5.46902 4.08613 4.97764 4.30499 4.52672C4.52386 4.07579 4.83376 3.67509 5.21516 3.34987C5.97914 2.66553 6.98209 2.30992 8.00652 2.36015C9.03095 2.41038 9.9943 2.8624 10.6877 3.6182C11.2153 4.1794 11.5534 4.89208 11.6543 5.6557C11.766 6.41633 11.6545 7.193 11.3335 7.89154C11.0114 8.58493 10.4801 9.15994 9.81433 9.5357C10.2727 9.71898 10.7208 9.92679 11.1568 10.1582C12.2191 10.7404 13.1126 11.5877 13.7502 12.6177C14.3878 13.6477 14.7478 14.8253 14.7952 16.0357V16.2024C14.8266 16.3958 14.8122 16.5939 14.753 16.7808C14.6937 16.9676 14.5914 17.1379 14.4543 17.2779C14.3171 17.4178 14.149 17.5236 13.9634 17.5867C13.7778 17.6497 13.58 17.6682 13.386 17.6407H8.61516L2.261 17.6399ZM16.9618 16.1049C16.8316 16.1125 16.7029 16.0737 16.5986 15.9955C16.4942 15.9172 16.421 15.8045 16.3918 15.6774C16.3368 15.4907 16.2885 15.3024 16.2435 15.1124C15.9041 13.8691 15.3174 12.707 14.5185 11.6957C14.1629 11.2017 13.7786 10.7289 13.3677 10.2799C13.0878 10.0112 12.7899 9.76198 12.476 9.53404C12.331 9.41654 12.2135 9.28404 12.3877 9.1107C12.7339 8.71682 12.9833 8.2474 13.1159 7.73996C13.2484 7.23253 13.2604 6.70112 13.151 6.1882C13.0989 5.62806 12.9441 5.0823 12.6943 4.5782C12.6805 4.55129 12.6685 4.52344 12.6585 4.49487C12.4977 4.08487 12.6127 3.91154 13.0527 3.8932C13.6843 3.87377 14.3064 4.04996 14.834 4.39768C15.3616 4.74539 15.7689 5.24764 16.0002 5.8357C16.217 6.42192 16.2397 7.06227 16.0651 7.6624C15.8905 8.26253 15.5277 8.79069 15.0302 9.16904C14.9935 9.1982 14.9593 9.22904 14.9043 9.2732C14.9386 9.29272 14.9746 9.30917 15.0118 9.32237C16.2159 9.60812 17.2665 10.3406 17.951 11.3715C18.5929 12.2322 18.9999 13.2451 19.1318 14.3107C19.1318 14.3465 19.1693 14.5032 19.1693 14.5032V15.0715C19.1499 15.113 19.1329 15.1556 19.1185 15.199C19.053 15.4503 18.9079 15.6737 18.705 15.8357C18.5021 15.9978 18.2522 16.0899 17.9927 16.0982C17.8435 16.1057 17.6943 16.1082 17.5443 16.1082C17.3493 16.1049 17.156 16.1049 16.9618 16.1049Z",
    fill: "#9196AF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1615_96254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileShare);
export default __webpack_public_path__ + "static/media/icon-profile-share.725c68fa1d70f1749a02f51a9a7a2410.svg";
export { ForwardRef as ReactComponent };